function getHostName() {
    if (typeof getHostName._hostName === 'undefined') {
        let hostname = window.location.origin;
        /**
         * Check the cases where the hostname is SVC and viewer is bundled with API
         * and deployed.
         */

        const urlMap = {
            test: 'https://svc-test.homeaway.com/havr-api',
            stage: 'https://svc-stage.homeaway.com/havr-api',
            production: 'https://svc.homeaway.com/havr-api',
        };
        // App was started with an explicit ENV parameter
        // eslint-disable-next-line no-undef
        if (urlMap[__ENV__]) {
            return urlMap[__ENV__]; // eslint-disable-line
            // Default to using test data when running locally
        } else if (hostname.includes('localhost')) {
            getHostName._hostName = urlMap.test;
            // If deployed somewhere weird, use production data
        } else if (!hostname.includes('svc') && !hostname.endsWith('homeaway.com')) {
            getHostName._hostName = urlMap.production;
            // Otherwise, use the same host
        } else {
            getHostName._hostName = `${hostname}/havr-api`;
        }
    }
    return getHostName._hostName;
}

async function getTour(tourId) {
    let response = await fetch(`${getHostName()}/v2/tours/${tourId}/public`);
    if (response.status !== 200) {
        throw response.json();
    }
    return response.json();
}

async function getNavigation(tourId) {
    let response = await fetch(`${getHostName()}/v2/tours/${tourId}/directNavigation`);
    if (response.status !== 200) {
        return null;
    }
    return response.json();
}

module.exports = {
    getTour,
    getNavigation,
    getHostName,
};
